var map = {
	"./Address/SDAddressConfig.js": "0d9a",
	"./Birthday/SBirthdayConfig.js": "7b88",
	"./City/SCityConfig.js": "8486",
	"./Email/SEmailConfig.js": "38d9",
	"./Fax/SDFaxConfig.js": "d46f",
	"./Identity/SDIdentityConfig.js": "da0c",
	"./Link/SLinkConfig.js": "cd1c",
	"./Mobile/SMobileConfig.js": "799e",
	"./RealName/SRealNameConfig.js": "7be9",
	"./SPhone/SSPhoneConfig.js": "af75",
	"./Sex/SSexConfig.js": "fc17",
	"./age/SAgeConfig.js": "da9b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2082";